import { render, staticRenderFns } from "./Onclick.vue?vue&type=template&id=19cbf8ce&"
import script from "./Onclick.vue?vue&type=script&lang=js&"
export * from "./Onclick.vue?vue&type=script&lang=js&"
import style0 from "./Onclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports